export default {
  styleOverrides: {
    root: {
      borderBottom: "none"
    }
  }
}
